import {
	Button,
	Col,
	ELanguage,
	MobileSort,
	Row,
	SlideModal
} from '@microfrontends/react-components'
import { useRouter } from 'next/router'
import { useContext, useRef, useState } from 'react'
import styled from 'styled-components'
import AppContext from '../../context/AppContext'
import { isMobile } from '../utils'
import { FixedBottomButtonCss } from './Common.css'
import FormCheckNumerology, { RefObj } from './FormCheckNumerology'
import { showLoginModal } from '../../helpers/buildLoginUrl'

const BASE_URL = process.env.VNW_BASE_URL

const ModalBottomCss = styled.div`
	padding: 0 16px 20px 16px;
`
export default function FixedBottomButton() {
	const { t, user, languageCode = ELanguage.VI } = useContext(AppContext)
	const [open, setOpen] = useState(false)
	const router = useRouter()
	const formRef = useRef<RefObj>(null)
	const handleClickSearch = () => {
		if (!user?.accessToken || user?.accessToken === '') {
			showLoginModal(languageCode)
			return
		}
		setOpen(true)
	}
	const handleOpen = () => {
		setOpen(!open)
	}
	return (
		<>
			{isMobile() ? (
				<>
					<FixedBottomButtonCss>
						<Row align='middle' justify='center'>
							<Col xs={24}>
								<Button
									type='primary'
									className='button__fixed'
									onClick={handleClickSearch}
								>
									{t('Tra cứu nhân số học')}
								</Button>
							</Col>
						</Row>
					</FixedBottomButtonCss>
					<SlideModal
						isOpen={open}
						onBack={() => {
							setOpen(false)
							formRef.current?.handleResetFormValues()
						}}
						title={t('Tra cứu nhân số học ')}
					>
						<ModalBottomCss>
							<FormCheckNumerology
								handleOpen={handleOpen}
								ref={formRef}
							/>
						</ModalBottomCss>
					</SlideModal>
				</>
			) : null}
		</>
	)
}
